/* unplugin-vue-components disabled */import { render } from "./HeaderAbout.vue?vue&type=template&id=32ab0b37"
import script from "./HeaderAbout.vue?vue&type=script&lang=js"
export * from "./HeaderAbout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__